"use strict";

class SftpSettingsController {

    constructor($scope, $timeout, SSHttpService, SSUtilService, SSAlertService, SSUserService, SSConfirmationService, SSAnalyticsService) {
        const self = this;

        self.$scope = $scope;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSAnalyticsService = SSAnalyticsService;

        self.SFTP_CATEGORY_INSTRUMENT = SHOWSUITE.SFTP_CATEGORY_INSTRUMENT;
        self.SFTP_CATEGORY_TOTAL_SOLD_AREA_AND_AMOUNT = SHOWSUITE.SFTP_CATEGORY_TOTAL_SOLD_AREA_AND_AMOUNT;
        self.SFTP_CATEGORY_PROJECT_DETAILS = SHOWSUITE.SFTP_CATEGORY_PROJECT_DETAILS;
        self.SFTP_CATEGORY_UNIT_DETAILS = SHOWSUITE.SFTP_CATEGORY_UNIT_DETAILS;
        self.SFTP_CATEGORY_OTP_DETAILS = SHOWSUITE.SFTP_CATEGORY_OTP_DETAILS;
        self.SFTP_CATEGORY_PURCHASER_DETAILS = SHOWSUITE.SFTP_CATEGORY_PURCHASER_DETAILS;
        self.SFTP_CATEGORY_REBATE_DETAILS = SHOWSUITE.SFTP_CATEGORY_REBATE_DETAILS;
        self.SFTP_CATEGORY_BUPA_DETAILS = SHOWSUITE.SFTP_CATEGORY_BUPA_DETAILS;
        self.SFTP_CATEGORY_PSM_DETAILS = SHOWSUITE.SFTP_CATEGORY_PSM_DETAILS;

        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;

        self.data = SHOWSUITE.data;

        self.SFTP_CATEGORIES = [
            {
                id: self.SFTP_CATEGORY_INSTRUMENT,
                display_name: "Instrument Posting"
            },
            {
                id: self.SFTP_CATEGORY_TOTAL_SOLD_AREA_AND_AMOUNT,
                display_name: "Total sold area & amount"
            },
            {
                id: self.SFTP_CATEGORY_PROJECT_DETAILS,
                display_name: "Project Details"
            },
            {
                id: self.SFTP_CATEGORY_UNIT_DETAILS,
                display_name: "Unit Details"
            },
            {
                id: self.SFTP_CATEGORY_OTP_DETAILS,
                display_name: "OTP Details"
            },
            {
                id: self.SFTP_CATEGORY_PURCHASER_DETAILS,
                display_name: "Purchaser Details"
            },
            {
                id: self.SFTP_CATEGORY_REBATE_DETAILS,
                display_name: "Rebate Details"
            },
            {
                id: self.SFTP_CATEGORY_BUPA_DETAILS,
                display_name: "BUPA Details"
            },
            {
                id: self.SFTP_CATEGORY_PSM_DETAILS,
                display_name: "PSM Details"
            }
        ]
        self.days_array = [];
        for (var i = 1; i <= 31; i++) {
            self.days_array.push(i);
        }
        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        let self = this;

        // Trigger View Event for API Configuration Page
        /* TODO: Need to confirm if need to trigger event
        self.SSAnalyticsService.saveAnalyticEvent({
                event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_API_CONFIGURATION,
                user_id: self.SSUtilService.getFromLocalStorage('user').id
            }
        );*/

        self.properties = null;
        self.sftp_settings = null;
        self.selected_ext_client = {};
        self.getDeveloperProperties();
        self.getSftpSettings();
    }

    getDeveloperProperties(){
        let self = this;

        let url = 'sec/developer/properties/list';
        let params = {
            status: self.PROPERTY_STATUS_APPROVED+","+ self.PROPERTY_STATUS_LISTED,
            summary: true
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.properties = response.data.properties;
        });
    }

    getSftpSettings() {
        let self = this;

        let url = 'sec/developer/sftp-settings';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.clear();
            self.sftp_settings = response.data.sftp_settings;
        });
    }

    editSftpSetting(sftp_setting = null) {
        const self = this;

        self.clearEditSftpErrors();
        self.selected_sftp_setting = {};
        if (sftp_setting) {
            self.selected_sftp_setting = angular.copy(sftp_setting);
        }

        self.hideModal();
        self.showSftpEditModal = true;
        self.sftp_settings_view_only_mode = false;
        if(self.selected_sftp_setting.schedule_date
                && self.selected_sftp_setting.category !== self.SFTP_CATEGORY_PROJECT_DETAILS
                && self.selected_sftp_setting.category !== self.SFTP_CATEGORY_UNIT_DETAILS){
            self.selected_sftp_setting.have_schedule = 'yes';
        }else{
            self.selected_sftp_setting.have_schedule = 'no';
        }

        let selected_property_ids = self.selected_sftp_setting.property_ids? self.selected_sftp_setting.property_ids.split(',') : [];
        self.initSelectizejs("properties_selectize", self.properties, selected_property_ids);
        $('#sftpEditModal').modal('show');
    }

    viewSftpSetting(sftp_setting = null) {
        const self = this;

        self.clearEditSftpErrors();
        self.selected_sftp_setting = {};
        if (sftp_setting) {
            self.selected_sftp_setting = angular.copy(sftp_setting);
        }

        self.hideModal();
        self.showSftpEditModal = true;
        self.sftp_settings_view_only_mode = true;

        self.initSelectizejs("properties_selectize", self.properties, []);
        $('#sftpEditModal').modal('show');
    }

    saveSftpSetting(){
        const self = this;

        if (!self.isValidSftpSetting()) return;

        let url = 'sec/developer/sftp-settings';

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            // Update local list
            if (self.selected_sftp_setting && self.selected_sftp_setting.id){
                self.sftp_settings = self.sftp_settings.map(s => {
                    return s.id !== self.selected_sftp_setting.id? s : self.selected_sftp_setting;
                })
            } else {
                self.sftp_settings.push(self.selected_sftp_setting)
            }

            self.SSAlertService.success('Saved successfully.');
            self.hideModal();
            self.getSftpSettings();
        }

        // Set is_enabled 0 if not checked/null on frontend as is always required on backend
        self.selected_sftp_setting.is_enabled = self.selected_sftp_setting.is_enabled || 0;

        // Clear extra fields
        delete self.selected_sftp_setting.password_view;
        delete self.selected_sftp_setting.key_view;
        delete self.selected_sftp_setting.secret_view;

        let params = angular.copy(self.selected_sftp_setting);
        params.property_ids = params.property_ids && Array.isArray(params.property_ids)? params.property_ids.join(",") : params.property_ids;

        if (params.id){
            url += '/'+params.id;
            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            loading(true);
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    deleteSftpSetting(id) {
        const self = this;

        if (!id) { return false; } // Invalid

        self.clearEditSftpErrors();
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this SFTP Setting?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/sftp-settings/' + id + '/delete';

                loading(true);
                self.SSHttpService.deleteAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    // Update local list
                    self.sftp_settings = self.sftp_settings.filter(s => s.id !== id);
                    self.SSAlertService.success('Removed successfully.');
                });
            }
        );
    }

    getSftpCategoryName(category_id) {
        let self = this;

        let category = self.SFTP_CATEGORIES.find(c => c.id === category_id);
        return category? category.display_name : "--";
    }

    getSftpCredentialTypeName(credential_type) {
        let self = this;

        return (!credential_type || credential_type === 'username_password')? 'Username /Password' : (credential_type === 'key')? 'Key' : '--';
    }

    isValidSftpSetting() {
        const self = this;

        self.clearEditSftpErrors();
        if (!self.selected_sftp_setting) {
            console.error("invalid settings object");
            return false;
        }

        let isValid = true;
        if (!self.selected_sftp_setting.host) {
            self.sftp_errors.host = 'Host is required';
            isValid = false;
        }
        if (!self.selected_sftp_setting.folder_path) {
            self.sftp_errors.folder_path = 'Folder path is required';
            isValid = false;
        }
        if (!self.selected_sftp_setting.category) {
            self.sftp_errors.category = 'Category is required';
            isValid = false;
        }
        if (!self.selected_sftp_setting.property_ids || !self.selected_sftp_setting.property_ids.length) {
            self.sftp_errors.property_ids = 'Property is required';
            isValid = false;
        }
        if (self.selected_sftp_setting.have_schedule === 'yes' && !self.selected_sftp_setting.schedule_date
                && self.selected_sftp_setting.category !== self.SFTP_CATEGORY_PROJECT_DETAILS
                && self.selected_sftp_setting.category !== self.SFTP_CATEGORY_UNIT_DETAILS) {
            self.sftp_errors.schedule_date = 'Please select schedule date.';
            isValid = false;
        }
        if (!self.selected_sftp_setting.credential_type) {
            self.sftp_errors.credential_type = 'Credential Type is required';
            isValid = false;
        }
        if ((self.selected_sftp_setting.credential_type && self.selected_sftp_setting.credential_type === 'username_password')
                && !self.selected_sftp_setting.username) {
            self.sftp_errors.username = 'Username is required';
            isValid = false;
        }
        if ((self.selected_sftp_setting.credential_type && self.selected_sftp_setting.credential_type === 'username_password')
                && !self.selected_sftp_setting.password) {
            self.sftp_errors.password = 'Password is required';
            isValid = false;
        }
        if ((self.selected_sftp_setting.credential_type && self.selected_sftp_setting.credential_type === 'key')
            && !self.selected_sftp_setting.key) {
            self.sftp_errors.key = 'Key is required';
            isValid = false;
        }
        /* Secret is optional
        if ((self.selected_sftp_setting.credential_type && self.selected_sftp_setting.credential_type === 'key')
            && !self.selected_sftp_setting.secret) {
            self.sftp_errors.secret = 'Secret is required';
            isValid = false;
        }*/

        return isValid;
    }

    clearEditSftpErrors(){
        const self = this;

        self.sftp_errors = {};
    }

    clearCredentialFields(){
        const self = this;

        self.selected_sftp_setting.username = self.selected_sftp_setting.password = null;
        self.selected_sftp_setting.key = self.selected_sftp_setting.secret = null;
    }

    hideModal() {
        const self = this;

        self.clearEditSftpErrors();
        self.showSftpEditModal = false;
        $('#sftpEditModal').modal('hide');
    }

    viewUploadHistory(){
        let self = this;

        let url = 'sec/developer/posting-file-details';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.clear();
            if(response && response.data) {
                self.upload_history = response.data.posting_file_details;
                if (self.upload_history && self.upload_history.length) {
                    self.upload_history = self.upload_history.map(h => {
                        if (h.file_url) {
                            let file_url_arr = h.file_url.split('/');
                            if (file_url_arr && file_url_arr.length){
                                h.filename = file_url_arr[file_url_arr.length-1]; // Get file name from url
                            }
                        }
                        return h;
                    })
                }
            }
            self.upload_history_view = true;
        });
    }

    downloadFile(file_id) {
        let self = this;

        if (!file_id) { return false; }

        let url = 'sec/developer/posting-file-details/'+ file_id +'/download';
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.clear();
            if(response && response.data && response.data.presigned_url) {
                window.open(response.data.presigned_url, '_blank')
            } else {
                self.SSAlertService.danger('Unable to generate file URL. Please try again or contact support.');
            }
        });
    }

    repostFile(file_id) {
        let self = this;

        if (!file_id) { return false; }

        let url = 'sec/developer/posting-file-details/'+ file_id +'/repost';
        loading(true);
        self.SSHttpService.postAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.clear();
            if (response) {
                self.SSAlertService.success('File successfully reposted.');
            }
        });
    }

    openPostingDateSelectionPopup(sftpSettingId, category){
        const  self = this;
        self.selectedSftpSettingId = sftpSettingId;
        self.manual_posting_date = self.SSUtilService.formatDateDMY(new Date()); // set today by default
        self.posting_date_popup_errors = {};

        if (!self.isDatepickerInitialized) {
            self.initializeDatepicker();
        } else {
            jQuery('.datepicker').datepicker("refresh");
        }
        $('#manual_posting_date_selection_popup').modal('show');

    }

    initializeDatepicker() {
        const  self = this;

        self.$timeout(function(){
            jQuery('.datepicker').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
            $(".datepicker.no_future_date").datepicker("option", "maxDate", "0");
            self.isDatepickerInitialized = true;
        });
    }

    scheduleSendEmailWithPostingDate() {
        const self = this;

        self.posting_date_popup_errors = {};
        if (!self.selectedSftpSettingId) { return; }
        if (!self.manual_posting_date) {
            self.posting_date_popup_errors.manual_posting_date = "Please select posting date."
            return;
        }

        $('#manual_posting_date_selection_popup').modal('hide');
        self.scheduleSendEmail(self.selectedSftpSettingId, self.manual_posting_date);
    }

    scheduleSendEmail(sftpSettingId, manual_posting_date) {
        const self = this;

        if (!sftpSettingId) { return false; }

        let url = 'sec/developer/sftp-settings/'+ sftpSettingId +'/send-manually';
        let params = {};

        if (manual_posting_date) {
            try {
                params.posting_date = self.SSUtilService.formatDateToStoreWithUtc12(manual_posting_date)
            } catch (e) { console.error(e); }
        }

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.clear();
            if (response) {
                self.SSAlertService.success('Posted successfully.');
            }
        });
    }

    getPropertiesNames(property_ids){
        const self = this;

        let names = "";
        if (!property_ids || !self.properties){ return names; }

        try{
            let propertyIdList = property_ids.split(',');
            if (propertyIdList && propertyIdList.length) {
                propertyIdList.forEach(property_id => {
                    let property = self.properties.find(p => p.id == property_id);
                    if(property){
                        names += names? ", " : "";
                        names += property.name;
                    }
                })
            }
        } catch(ex){
            console.error(ex);
        }

        return names ? names : '--';
    }

    initSelectizejs(selectize_id, options, selected_items = []) {
        const self = this;

        if (!selectize_id || !options) { return false; }

        // Remove selected 'items' from previous records, if any
        try{
            let selectize = $("#"+selectize_id)[0]? $("#"+selectize_id)[0].selectize : null;
            if(selectize){
                selectize.destroy();
            }

            // selectize usage documentation:
            // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
            self.$timeout(function() {
                $("#"+selectize_id).selectize({
                    valueField: 'id',
                    labelField: 'name',
                    sortDirection: 'desc',
                    maxItems: null,
                    options: options,
                    create: false,
                    items: selected_items,
                });
            })
        } catch(ex){
            console.error(ex);
        }
    }
}

SftpSettingsController.$inject = ['$scope', '$timeout', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSUserService', 'SSConfirmationService', 'SSAnalyticsService'];
app.controller('SftpSettingsController', SftpSettingsController);